module.exports = __webpack_public_path__ + "static/img/taxcellent_bg_01_h5.9efdf5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/taxcellent_bg_01_h5.png
// module id = SWrT
// module chunks = 34